
export interface RoleModel {

    id?: number;
    name?: RoleEnum;
}



export enum RoleEnum {
    ADMIN = "ADMIN",
    SECURITY = "SECURITY",
    CUSTOMER_SERVICES = "CUSTOMER_SERVICES",
    USER = "USER",
    SECURITY_MANAGER = "SECURITY_MANAGER"
}

export enum UserRulesDisplayNames {
    ADMIN = "Business User",
    CUSTOMER_SERVICES = "Agent",
    SECURITY = "Security",
    USER = "User",
    SECURITY_MANAGER = "Security Manager"
}